import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Spinner,
  useDisclosure
} from '@chakra-ui/react'
import paginate from 'paginate-array'
import { FC, useMemo, useState } from 'react'
import Paginate from 'react-paginate'

import useProfile from '@hook/shared/use-profile'

import ProfilesModalTableTr from './Tr'

const ProfilesTable: FC = () => {
  const { onOpen } = useDisclosure()
  const {
    profiles,
    loading,
    getProfiles,
    profileQuery: fastQuery
  } = useProfile()

  const [_selected, setSelected] = useState<any>()

  const [page, setPage] = useState(1)

  const pagination = useMemo(() => {
    let toSearch = profiles

    if (fastQuery.length > 0) {
      const query = fastQuery.toLowerCase()

      toSearch = toSearch.filter((row: any) =>
        JSON.stringify(row).toLowerCase().includes(query)
      )
    }

    const arr = paginate(toSearch, page, 12)

    return arr
  }, [page, profiles, fastQuery])

  const handleUserEdit = (profiles: any) => {
    setSelected(profiles)
    onOpen()
  }

  return (
    <Box px={0} py={6}>
      {loading ? (
        <Flex
          h="220px"
          flexDir="column"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner size="lg" color="yellow.400" mb={4} />
          <Text maxW="420px" textAlign="center">
            Obtendo perfis... aguarde!
          </Text>
        </Flex>
      ) : (
        <>
          <Table variant="simple" size="sm" mb={8}>
            <Thead>
              <Tr>
                <Th>Nome</Th>
                <Th>Descrição</Th>
                <Th>Acesso</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pagination.data.map((profiles: any, index: number) => (
                <ProfilesModalTableTr
                  key={`profile-${index}`}
                  data={profiles}
                  onSelect={handleUserEdit}
                  onUpdate={getProfiles}
                />
              ))}
            </Tbody>
          </Table>

          {profiles.length > 0 && (
            <Paginate
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageCount={pagination.totalPages}
              forcePage={pagination.currentPage - 1}
              pageRangeDisplayed={5}
              marginPagesDisplayed={1}
              previousLabel={'Página anterior'}
              nextLabel={'Próxima página'}
              onPageChange={({ selected }: any) => {
                setPage(selected + 1)
              }}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default ProfilesTable
